// @flow
import actions from "./actions";
import types from "./types";
import AppOperations from "../App/operations";
import type {Dispatch} from "redux";
import {strings} from "../../../config";
import CurrentRequestOperations from "../CurrentRequest/operations";
import type {CurrentRide} from "../CurrentRide/reducers";
import type {GetState} from "../../Store";
import CurrentRideOperations from "../CurrentRide/operations";
import BackendTypes from "../../Middleware/Backend/types";

const updateProposalData = actions.updateProposalData;

const proposalTimedOut = () => {
    return (dispatch: Dispatch, getState: GetState) => {
        dispatch(actions.proposalTimeout());
        dispatch(AppOperations.showAlert({
            content: strings.alert_message_proposal_timed_out_content_text,
            buttons: [
                {
                    text: strings.alert_message_proposal_timed_out_confirm_button_text,
                    actions: [BackendTypes.MIDDLEMAN_RIDE_REQUEST]
                },
                {
                    text: strings.alert_message_proposal_timed_out_cancel_button_text,
                    actions: [types.PROPOSAL_DATA_CLEAR, BackendTypes.MIDDLEMAN_INVALIDATE_REQUEST]
                },
            ]
        }));
    };
};

const resetCurrentProposal = actions.resetCurrentProposal;

const failProposalRequest = (error: Object) => {
    return (dispatch: Dispatch, getState: GetState) => {
        dispatch(CurrentRequestOperations.invalidateRequestDestOrOrigin());
        dispatch(AppOperations.showAlert({content: error.info}));
    };
};
const failProposalAccept = (error: Object) => {
    return (dispatch: Dispatch, getState: GetState) => {
        dispatch(CurrentRequestOperations.invalidateRequestDestOrOrigin());
        dispatch(AppOperations.showAlert({content: error.info}));
    };
};

const handleAcceptedProposalSuccess = (acceptedProposal: CurrentRide) => {
    return (dispatch: Dispatch, getState: GetState) => {
        const payload = acceptedProposal.ride_id ?
            {
                ride_id: acceptedProposal.ride_id,
                acceptedTimestamp: new Date(),
                awaitingDriverApproval: false,
            } : {
                awaitingDriverApproval: true,
            };
        return dispatch(CurrentRideOperations.rideDataUpdate(payload));
    };
};

const acceptProposal = actions.acceptProposal;

export default {
    updateProposalData,
    proposalTimedOut,
    resetCurrentProposal,
    failProposalRequest,
    failProposalAccept,
    handleAcceptedProposalSuccess,
    acceptProposal,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentProposal/operations.js